import isNil from "lodash/isNil";
import { minutesToReadableDuration } from "PFCore/helpers/date";
import { roundToDecimals } from "PFCore/helpers/rounding";
import { KPIUnit } from "PFCore/types/kpi";

export const KPIUnitMap = {
  [KPIUnit.Percentage]: "%",
  [KPIUnit.Hours]: "h"
};

export const getKpiDisplayValue = (value: number | null, unit: KPIUnit): number | null => {
  if (isNil(value)) {
    return null;
  }

  return unit === KPIUnit.Hours ? roundToDecimals(value / 60) : roundToDecimals(value);
};

export const getKPIFormattedValue = (value: number | null, unit: KPIUnit, decimals: number = 0): string => {
  if (isNil(value)) {
    return "-";
  }

  const roundedValue = roundToDecimals(value, decimals);

  return unit === KPIUnit.Hours
    ? minutesToReadableDuration(roundedValue)
    : `${roundedValue}${KPIUnitMap[unit]}`;
};

export const getKPIFormattedRange = (
  min: number | null,
  max: number | null,
  unit: KPIUnit
): string | null => {
  if (isNil(min) && isNil(max)) {
    return "0 - ∞";
  }

  const formattedMinValue = getKpiDisplayValue(min, unit);
  const formattedMaxValue = getKpiDisplayValue(max, unit);

  const unitSuffix = KPIUnitMap[unit];

  if (isNil(formattedMinValue)) {
    return `0 - ${formattedMaxValue}${unitSuffix}`;
  }

  if (isNil(formattedMaxValue)) {
    return `≥ ${formattedMinValue}${unitSuffix}`;
  }

  return `${formattedMinValue} - ${formattedMaxValue}${unitSuffix}`;
};

export const getKPIFormattedDeviation = (deviationPercentage: number | null): string => {
  if (isNil(deviationPercentage)) {
    return "-";
  }

  return `${getKpiDisplayValue(deviationPercentage, KPIUnit.Percentage)}%`;
};
